import {configurationOptions, rootStore} from '@/store/types'
import {Module} from 'vuex'
import {mutations} from './mutations'
import {getters} from './getters'

const state: configurationOptions = {
    navigation: [
        {
            name: 'first',
            displayDescription: 'first',
            displayName: 'first'
        }
    ],
    introduction: {
        heading: 'This is heading',
        text: 'Īss ceļa apraksts test test test',
        button: 'Proceed'
    }
}

export const config: Module<configurationOptions, rootStore> = {
    state,
    mutations,
    getters,
    namespaced: true
}